export const firebaseConfig = {
  apiKey: 'AIzaSyC0mZGC3n-rzC5twOMpb3m-lzDP4ISPgps',
  authDomain: 'patch-me.firebaseapp.com',
  databaseURL: 'https://patch-me.firebaseio.com',
  projectId: 'patch-me',
  storageBucket: 'patch-me.appspot.com',
  messagingSenderId: '577190368123',
  appId: '1:577190368123:web:9679d8078c4790a2aca3de'
};
